<template>
  <section class="home">
    <za-banner></za-banner>
    <article class="article">
      <section class="article-inner">
        <template v-for="(item, index) in reportsList">
          <div class="article-item" :key="index">
              <img class="article-item-img" :src="item.img" alt="">
              <div class="item-right">
                <h2 class="article-item-title">{{item.title}}</h2>
                <p class="article-item-desc">{{item.desc}}</p>
              </div>
          </div>
        </template>
      </section>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      reportsList: [{
        img: require('../assets/part1.png'),
        title: '【双账号同时登录，无限多开】',
        desc: '手机应用双开是指在一个设备上开启两个一样的应用，可以同时登录两个账号，并同时在后台运行。应用游戏不止双开，更能多开。 '
      }, {
        img: require('../assets/part2.png'),
        title: '【用密码图案保护，隐私加密】',
        desc: '应用锁的帮助下，再也不用担心朋友借用你的手机可能会发现你的小秘密，任何双开应用都可以添加保护的应用程序的隐私安全。'
      }, {
        img: require('../assets/part3.png'),
        title: '【黑科技应用伪装，轻松隐藏】 ',
        desc: '非常实用的应用伪装功能，不管是什么双开应用都可以设置为自定义的应用图标和名称。隐藏你手掌心的密码，给你更多私人空间。'
      }]
    }
  },
  methods: {
    toLogin() {
      this.$router.push('./login')
    }
  }
}
</script>
<style scoped>
.article {
  min-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.article-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  padding: 50px 100px;
  width: 100%;
}
.article-item:nth-child(2) {
  background-color: #F6F6F6;
}
.article-item-title {
  width: 100%;
  font-size: 26px;
  margin: 20px 0;
  color: #000;
}
.article-item-desc {
  font-size: 16px;
  line-height: 30px;
  color: #333;
}
.more-link {
  text-align: center;
}
.more-link a {
  font-size: 18px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  color: #016091;
  padding-bottom: 1px;
}
.more-link a:hover {
  border-bottom: 1px solid #016091;
}
.more-link a span {
  font-weight: 700;
}
.sub-title {
  margin: 50px;
  text-align: center;
}
.item-right {
  display: inline-block;
  width: 400px;
  margin: 30px 50px;
  text-align: left;
}
.article-item-img {
  /* width: 381px;
  height: 600px; */
}
</style>